import React, {useState} from 'react';
import { useForm } from "react-hook-form";
import axiosInstanceWithToken from "../../containers/axiosInstanceWithToken";

const apiUrl = process.env.REACT_APP_APIGATEWAY_ENDPOINT;

const Inquiry = () => {
    const { register, handleSubmit, formState: { errors }  } = useForm();
    const [contentLength, setContentLength] = useState(0);
    const handleContentChange = (e) => {
        setContentLength(e.target.value.length);
    };

    const onSubmit =(data) => {
        const formData = new FormData();

        Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
        });

        axiosInstanceWithToken.post(apiUrl + "/common/regular/board/inquiry", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            alert("문의 내용이 전송되었습니다.")
            window.location.href= "/inquiry";
        }).catch((error) => {
            const statusCode = error.response.status ? error.response.status : error.status;
            if(statusCode === 401){

            }else {
                alert("실패 다시 시도해주세요")
            }
        })
    }

    return (
        <div className="col-xl-6 mx-auto pb-10 border-bottom">
            <h6 className="font-weight-medium font-size-10 mb-3 pb-xl-1">1:1 문의</h6>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">

                    <div className="col-sm-12 mb-5"></div>
                    <div className="col-sm-12 mb-5">
                        <div className="js-form-message">
                            <label htmlFor="title">제목</label>
                            <input id="title" type="text" className="form-control rounded-0"
                                   name="title"
                                   {...register("title", {
                                       required: "제목을 입력해주세요.",
                                       maxLength: {
                                           value: 100,
                                           message: "제목은 100자 이내로 입력해주세요."
                                       }
                                   })}/>
                        </div>
                        {errors.title && <div className="text-red-1 font-size-2">{errors.title.message}</div>}
                    </div>
                    <div className="col-sm-12 mb-5">
                        <div className="js-form-message">
                            <div className="input-group flex-column">
                                <label htmlFor="content">문의내용</label>
                                <textarea id="content"
                                          className="form-control rounded-0 pl-3 font-size-2 placeholder-color-3"
                                          rows="6" cols="77" name="content"
                                          placeholder="문의 내용을 작성해주세요"
                                          {...register("content", {
                                                required: "내용을 입력해주세요.",
                                                maxLength: {
                                                    value: 3000,
                                                    message: "내용은 3000자 이내로 입력해주세요."
                                                }
                                          })}
                                          onChange={(e) => {
                                              register("content").onChange(e);
                                              handleContentChange(e);
                                          }}>
                                </textarea>
                                <div className="text-right"><small>{contentLength}/3000</small></div>
                            </div>
                            {errors.content && <div className="text-red-1 font-size-2">{errors.content.message}</div>}
                        </div>
                    </div>

                    <div className="col d-flex justify-content-lg-start">
                        <button type="submit"
                                className="btn btn-wide btn-dark text-white rounded-0 transition-3d-hover height-60 width-175">
                            문의하기
                        </button>
                    </div>
                    <div className="font-size-2 text-gray-700 pl-3 pt-1">* 문의 답변은 이메일로 전송됩니다.</div>
                </div>
            </form>
        </div>
    )
}

export default Inquiry;